var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"register-user-proto-model",attrs:{"title":"用户协议","buttons-hidden":""}},[_c('iframe',{attrs:{"src":"/register-proto.html","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }